module.exports = __webpack_public_path__ + "img/物流.3b637b58.png";